import React from "react"
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  Legend,
} from "recharts"
import {chartsPallete} from "../../../assets/shared/colorConstants"
import {shortenNumber} from "../../../utils/utils"
import ChartTooltip from "../ChartTooltip"

// accepts chartData, xDataKey, yDataKey as props to generate the simple bar chart. Here yLabel and labelList are optional used for selected charts only

export default function MultiColorBarChart({
  chartData,
  xDataKey,
  yDataKey,
  yLabel,
  labelList,
  chartHeight,
  barSize,
  showLegend,
  shortenLabelValue,
  color,
  marginRight,
  marginTop,
}) {
  const tableLableList = (() =>
    labelList ? (
      <LabelList
        dataKey={yDataKey}
        position="top"
        fill="#000"
        offset={8}
        formatter={(val) => (!shortenLabelValue ? `${val}%` : `${shortenNumber(val, 1)}`)}
      />
    ) : (
      false
    ))()

  return (
    <ResponsiveContainer height={chartHeight ? chartHeight : 364} width="100%">
      <BarChart
        data={chartData}
        margin={{
          top: marginTop ? marginTop : 0,
          right: marginRight ? marginRight : 0,
        }}
        maxBarSize={140}
      >
        <CartesianGrid
          vertical={false}
          strokeOpacity="0.6"
          strokeDasharray="4 4"
          color="#0A3F36"
        />
        <XAxis
          dataKey={xDataKey}
          strokeOpacity="1"
          stroke="#0A3F36"
          tickLine={false}
          tick={{dy: 5}}
        />
        <YAxis
          axisLine={false}
          label={
            yLabel
              ? {
                  value: yLabel,
                  angle: -90,
                  position: "insideLeft",
                  style: {opacity: 0.6},
                }
              : false
          }
          tickLine={false}
          tickFormatter={(tick) =>
            !shortenLabelValue ? `${tick}%` : `${shortenNumber(tick, 1)}`
          }
        />
        <Tooltip
          formatter={(value, name) =>
            !shortenLabelValue ? `${value}%` : `${shortenNumber(value, 1)}`
          }
          labelFormatter={function (value) {
            return `${value}`
          }}
          xDataKey={xDataKey}
          content={<ChartTooltip />}
        />

        {color ? (
          <Bar dataKey={yDataKey} fill={color} barSize={barSize ? barSize : ""}>
            {tableLableList}
          </Bar>
        ) : (
          <Bar dataKey={yDataKey} barSize={barSize ? barSize : ""}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={chartsPallete[index]} />
            ))}{" "}
            {tableLableList}
          </Bar>
        )}

        {showLegend && (
          <Legend
            verticalAlign="bottom"
            iconType="circle"
            iconSize={12}
            align="center"
            wrapperStyle={{bottom: -12, left: 40, color: "#4A4A4A"}}
          />
        )}
      </BarChart>
    </ResponsiveContainer>
  )
}
